module.exports = __webpack_public_path__ + "static/img/login_4.d577a32.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/login_4.webp
// module id = Qavd
// module chunks = 0